import { computed } from "@ember/object"
import Component from "@glimmer/component"
import styles from "./dropdown-menu.module.css"

interface Signature {
  Args: {
    arrowPlacement?: string
    iconColumns?: string
  }
  Element: HTMLDivElement
  Blocks: {
    default?: any
  }
}
export default class DropdownMenu extends Component<Signature> {
  readonly styles = styles

  @computed("arrowPlacement")
  get arrowClass() {
    // if (this.arrowPlacement === "NONE") {
    //   return ""
    // } else if (this.arrowPlacement === "TOP_CENTER") {
    //   return "--arrow --arrow-center"
    // } else if (this.arrowPlacement === "TOP_RIGHT") {
    //   return "--arrow --arrow-right"
    // } else {
    //   return "--arrow --arrow-right"
    // }
    if (this.args.arrowPlacement === "NONE") {
      return ""
    } else if (this.args.arrowPlacement === "TOP_CENTER") {
      return `${styles["--arrow"]} ${styles["--arrow-center"]}`
    } else if (this.args.arrowPlacement === "BOTTOM_RIGHT") {
      return `${styles["--arrow"]} ${styles["--arrow-bottom-right"]}`
    } else if (this.args.arrowPlacement === "BOTTOM_CENTER") {
      return `${styles["--arrow"]} ${styles["--arrow-bottom-center"]}`
    } else if (this.args.arrowPlacement === "MIDDLE_RIGHT") {
      return `${styles["--arrow"]} ${styles["--arrow-middle-right"]}`
    } else {
      return `${styles["--arrow"]} ${styles["--arrow-else-right"]}`
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "DS::DropdownMenu": typeof DropdownMenu
  }
}
